module.exports = __webpack_public_path__ + "static/img/banner-易企销@2x.7a2df2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-易企销@2x.png
// module id = Kfae
// module chunks = 1